import type { Artwork } from "./types";

export const paintings: Artwork[] = [
  {
    id: "p1",
    title: "Photo 2025-03-18, 4 31 09 PM",
    year: 2025,
    medium: "Acrylic on Canvas",
    thumbnail: "/gallery/paintings/thumbs/photo-2025-03-18-4-31-09-pm.jpg",
    fullImage: "/gallery/paintings/full/Photo 2025-03-18, 4 31 09 PM.jpg",
    date: "2025-03-18",
  },
  {
    id: "p2",
    title: "Photo 2026-02-08, 9 24 28 PM (1)",
    year: 2026,
    medium: "Acrylic on Canvas",
    thumbnail: "/gallery/paintings/thumbs/photo-2026-02-08-9-24-28-pm-1.jpg",
    fullImage: "/gallery/paintings/full/Photo 2026-02-08, 9 24 28 PM (1).jpg",
    date: "2026-02-08",
  },
  {
    id: "p3",
    title: "Photo 2026-02-08, 9 24 28 PM",
    year: 2026,
    medium: "Acrylic on Canvas",
    thumbnail: "/gallery/paintings/thumbs/photo-2026-02-08-9-24-28-pm.jpg",
    fullImage: "/gallery/paintings/full/Photo 2026-02-08, 9 24 28 PM.jpg",
    date: "2026-02-08",
  },
];
